﻿import * as Models from '../../models/models';

export class BillSummaryViewModel {
    userProfile: Models.IUserProfile;
    policyholder: Models.IPolicyholder;
    billingStatement: Models.IBillingStatement;
    cardPaymentMethods: Array<Models.ICardPaymentMethod>;
    echeckPaymentMethods: Array<Models.IEcheckPaymentMethod>;
    selectedPaymentTokenId: string = "";
    isSubmitted:boolean = false;


    public isPastDue = (): boolean => {
        if (typeof (this.billingStatement) != "undefined") {
            return this.billingStatement.pastDueBalance > 0;
        }
        return false;
    }

    public doCardPaymentMethodsExist = (): boolean => {

       if (typeof (this.cardPaymentMethods) != "undefined") {

           if (this.cardPaymentMethods.length > 0) {
               return true;
           }
       }
       return false;
   }

    public doEcheckPaymentMethodsExist = (): boolean => {

        if (typeof (this.echeckPaymentMethods) != "undefined") {

            if (this.echeckPaymentMethods.length > 0) {
                return true;
            }
        }

        return false;
    }

    public doPaymentMethodsExist = (): boolean => {

        if (this.doCardPaymentMethodsExist()) {
            return true;
        }

        if (this.doEcheckPaymentMethodsExist()) {

            return true;
        }

        return false;
    }

    public amountDueHeader = (): string => {
        if (this.isPastDue()) {
            return "Past Due Amount";
        } else {
            return "Amount Due";
        }
    }

    public amountDueValue = (): number => {

        if (typeof (this.billingStatement) != "undefined") {
            if (this.isPastDue()) {
                return this.billingStatement.pastDueBalance;
            } else {
                return this.billingStatement.billedAndUnpaidBalance;
            }
        } else {
            return 0;
        }
    }

    public autoPayStatus = (): string => {

        if (typeof (this.policyholder) != "undefined") {
            if (this.policyholder.autopay) {
                return "ON";
            } else {
                return "OFF";
            }
        } else {
            return "";
        }

    }

    public creditCardType = (creditCardTypeCode: string): string => {
        if (creditCardTypeCode === "001") {
            return "VISA";
        }
        if (creditCardTypeCode === "002") {
            return "MASTERCARD";
        }
        if (creditCardTypeCode === "003") {
            return "AMERICAN EXPRESS";
        }
        if (creditCardTypeCode === "004") {
            return "DISCOVER";
        }
    }

    public bankAccountType = (accountTypeCode: string): string => {
        if (accountTypeCode === "c") {
            return "CHECKING";
        }
        if (accountTypeCode === "s") {
            return "SAVINGS";
        }
        if (accountTypeCode === "x") {
            return "CORPORATE CHECKING";
        }

        if (accountTypeCode === "g") {
            return "GENERAL LEDGER";
        }
        
    }
}
